import { Box, Divider, TextField } from '@mui/material'
import { BoxFC, BoxFR } from 'components/BoxCustom'
import DataGridCellExpand from 'components/DataGridCellExpand/DataGridCellExpand'
import DateTimeSelect from 'components/DateTimeSelect'
import ComboBox from 'components/ComboBox'
import SearchButton from 'components/buttons/SearchButton'
import ClearButton from 'components/buttons/ClearButton'
import AddButton from 'components/buttons/AddButton'
import { GlobalStateContext } from 'contexts/GlobalStateContext'
import { alertConfirmDelete, alertError, alertSuccess } from 'components/Alert'
import React, { useCallback, useContext, useEffect, useState } from 'react'
import { addIdForDataGrid } from 'utils'
import { initFilterData, clearFilterData, initAddData } from './initData'
import { driverAdvancePayV2Columns } from './columns'

const DriverAdvancePayV3 = () => {
  const { ax, msData } = useContext(GlobalStateContext)
  const [dataTable, setDataTable] = useState([])
  const [filterData, setFilterData] = useState({ ...initFilterData })
  const [addData, setAddData] = useState({ ...initAddData })

  const getData = useCallback((filter) => {
    ax.post("/branch/driver-payroll-v3/getAdvancePays", {
      DrvId: filter.DrvId,
      PayTmSt: filter.PayTmSt ? filter.PayTmSt.substring(0, 10) : null,
      PayTmEn: filter.PayTmEn ? filter.PayTmEn.substring(0, 10) : null,
    }).then(value => { if (value.data) setDataTable(addIdForDataGrid(value.data, 'id')) })
  }, [ax])

  const handleAdd = useCallback(() => {
    if (!addData.DrvId || !addData.Amnt) { alertError("กรุณาเลือกพนักงานและระบุจำนวนเงิน"); return }
    ax.post("/branch/driver-payroll-v3/insertAdvancePay", {
      DrvId: addData.DrvId, Amnt: +addData.Amnt, Dscp: addData.Dscp || null,
    }).then(value => { if (value.data != null) { alertSuccess("บันทึกเงินเบิกล่วงหน้าแล้ว"); setAddData({ ...initAddData }); getData(filterData) } })
  }, [ax, addData, filterData, getData])

  const handleDelete = useCallback((row) => {
    alertConfirmDelete(() => {
      ax.post("/branch/driver-payroll-v3/deleteAdvancePay", { PCTrnsId: row.PCTrnsId })
        .then(value => { if (value.data) getData(filterData) })
    })
  }, [ax, filterData, getData])

  const columns = driverAdvancePayV2Columns(handleDelete)

  useEffect(() => { getData({ ...initFilterData }) }, [getData])

  return (
    <BoxFC height='100%'>
      <BoxFR>
        <ComboBox sx={{ width: 170 }} options={msData.driverOnlyCombo} label="พนักงานขับรถ (เพิ่ม)"
          selectedId={addData.DrvId} setSelectedId={(id) => setAddData(o => ({ ...o, DrvId: id }))} />
        <TextField size="small" sx={{ width: 100 }} label="จำนวนเงิน" type="number"
          value={addData.Amnt} onChange={e => setAddData(o => ({ ...o, Amnt: e.target.value }))} />
        <TextField size="small" sx={{ width: 160 }} label="หมายเหตุ"
          value={addData.Dscp} onChange={e => setAddData(o => ({ ...o, Dscp: e.target.value }))} />
        <AddButton onClick={handleAdd}>เพิ่มเงินเบิก</AddButton>
        <Box flex={1} />
        <ComboBox sx={{ width: 170 }} options={msData.driverOnlyCombo} label="กรองพนักงาน"
          selectedId={filterData.DrvId} setSelectedId={(id) => setFilterData(o => ({ ...o, DrvId: id }))} />
        <DateTimeSelect sx={{ width: 180 }} label='วันที่เบิก' start={filterData.PayTmSt} end={filterData.PayTmEn}
          setSelectDate={(st, en) => setFilterData(o => ({ ...o, PayTmSt: st, PayTmEn: en }))}
          getData={() => getData(filterData)} />
        <SearchButton onClick={() => getData(filterData)} />
        <ClearButton onClick={() => setFilterData({ ...clearFilterData })} />
      </BoxFR>
      <Divider sx={{ my: 1 }} />
      <Box height='100%'>
        <DataGridCellExpand hideFooter rows={dataTable} columns={columns} />
      </Box>
    </BoxFC>
  )
}

export default DriverAdvancePayV3
